export const OrderSelector: React.FC<{
  sortOrder: 'asc' | 'desc';
  setSortOrder: (order: 'asc' | 'desc') => void;
}> = ({ sortOrder, setSortOrder }) => (
  <div className='w-full flex items-center px-2'>
    <select
      className='appearance-none p-2.5 pr-8 shadow-md rounded-2xl w-full bg-gray-200 hover:bg-gray-300 transition duration-300 text-sm font-medium focus:outline-none cursor-pointer'
      value={sortOrder}
      onChange={(e) => setSortOrder(e.target.value as 'asc' | 'desc')}
    >
      <option value='desc'>Más reciente</option>
      <option value='asc'>Menos reciente</option>
    </select>
  </div>
);
